import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Wrapper, MenuText } from '@ecp/fo/sites/skypass/styles/gnb/SkypassGnbHeaderBottomStyles';
import SkypassGnbHeaderBottomUserInfo from '@ecp/fo/sites/skypass/components/gnb/SkypassGnbHeaderBottomUserInfo';

export default function SkypassGnbHeaderBottom({ gnbList }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const menuList = useMemo(() => toMenuList(), [gnbList]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const index = getInitSlide();
    setSelectedIndex(index);
  }, [menuList, pathname]);

  function getInitSlide() {
    const index = menuList.findIndex((it) => {
      return isMatchPath(it.link);
    });

    return index;
  }

  function toMenuList() {
    const menuList = gnbList.map((menu) => ({ ...menu, name: menu.title }));
    menuList.unshift({ name: '홈', link: '/' });

    return menuList;
  }

  function onClickMenu(link, idx) {
    navigate(link);
    setSelectedIndex(idx);
  }

  function isMatchPath(path) {
    // 쿼리스트링, 해시 제거
    const cleanPath = path.split(/[?#]/)[0];

    // 서버에서 내려주는 path가 맨 앞에 /가 안붙을 때를 대응
    return cleanPath === pathname || `/${cleanPath}` === pathname;
  }

  return (
    <Wrapper>
      {menuList.map((it, idx) => {
        return (
          <MenuText key={idx} active={selectedIndex === idx} onClick={() => onClickMenu(it.link, idx)}>
            {it.name}
          </MenuText>
        );
      })}
      <SkypassGnbHeaderBottomUserInfo />
    </Wrapper>
  );
}

SkypassGnbHeaderBottom.propTypes = {
  gnbList: PropTypes.array,
};
